import { useToastStore } from '@/store';

export function useToasts() {
  const toastStore = useToastStore();

  const success = message => {
    toastStore.add('success', message);
  };

  const info = message => {
    toastStore.add('info', message);
  };

  const warning = message => {
    toastStore.add('warning', message);
  };

  const error = message => {
    toastStore.add('danger', message);
  };

  return { success, info, warning, error };
}
